// material-ui
import { Box } from '@mui/material';

// assets

// ==============================|| HEADER CONTENT - SEARCH ||============================== //

const Search = () => <Box sx={{ width: '100%', ml: { xs: 0, md: 1 } }}></Box>;

export default Search;
